export default {
  data() {
    return {
      containerHeight: 0,
      standardHeight: 0
    }
  },
  mounted() {
    this.standardHeight = window.innerHeight - 180;
    window.addEventListener('resize', this.handResize);
  },
  methods: {
    getContinaerDom() {
      return document.getElementById('coin-manage') || document.getElementById('coin-record')
      // console.log(document.getElementById('coin-manage'))
      // console.log(document.getElementById('coin-record'))
    },
    handResize() {
      this.containerHeight = 0;
      this.containerHeight = this.getContinaerDom().offsetHeight;
      this.standardHeight = window.innerHeight - 180;
      // console.log(this.containerHeight)
    }
  },
  watch: {
    tableList: {
      deep: true,
      handler() {
        this.containerHeight = 0;
        this.$nextTick(() => {
          this.containerHeight = this.getContinaerDom().offsetHeight;
        });
      }
    }
  },
  computed: {
    tableList() {
      return this.currentSelected === 1 ?
        this.tableData
        : this.staffTableData;
    },
    asideHeight() {
      if (this.containerHeight > this.standardHeight) {
        return this.containerHeight;
      } 
        return this.standardHeight;
      
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handResize);
  },
}